import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Moon, Sparkles } from "lucide-react";

export const ExpiredReading = () => (
  <section
    data-testid="expired-reading"
    className="relative min-h-[80vh] flex flex-col items-center justify-center px-6 py-20 text-center"
  >
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
      className="flex flex-col items-center max-w-lg"
    >
      <div className="w-20 h-20 rounded-full border border-stardust/20 flex items-center justify-center mb-8 bg-stardust/[0.04]">
        <Moon className="h-8 w-8 text-stardust/60" />
      </div>

      <p className="text-stardust/70 uppercase tracking-[0.5em] text-[10px] mb-5">An almanac has set</p>

      <h1 className="font-display text-4xl sm:text-5xl text-[#F5EBD8] mb-5 leading-tight">
        This reading has<br />returned to the stars<span className="text-stardust">.</span>
      </h1>

      <p className="font-serif-italic text-slate-300 text-lg sm:text-xl leading-relaxed mb-10">
        Each shared almanac lives for seven days, then quietly disappears from our records.
        The wheel always turns. Yours can begin anew.
      </p>

      <Link
        to="/"
        data-testid="expired-cta"
        className="inline-flex items-center gap-3 bg-stardust hover:bg-stardust-light text-cosmic-900 font-medium uppercase tracking-[0.3em] text-[11px] px-10 py-5 rounded-md shadow-[0_0_40px_rgba(226,194,117,0.25)] hover:shadow-[0_0_55px_rgba(226,194,117,0.45)] transition-all duration-300"
      >
        <Sparkles className="h-4 w-4" />
        Consult the wheel
      </Link>

      <p className="text-slate-500 text-xs uppercase tracking-[0.25em] mt-8">
        Free · No sign-up
      </p>
    </motion.div>
  </section>
);
